
var ProductDisplayToggle = class extends CustomHTMLElement {
    constructor() {
        super();
        this.linksURL = null;
        this.currentMode = 'full';
        this.displayModeButton = this.querySelectorAll('span');
        this.facetFiltersFormId = "facet-filters-form";
        this.productItems = Array.from(this.querySelectorAll("product-item"));
    }

    connectedCallback() {
        this.delegate.on("click", 'span', this._onClickHandle.bind(this));
        this.checkMobile();
    }

    checkMobile() {
        if (window.innerWidth < 999) {
            this.updateMode('more', this.displayModeButton[1]);
            this.refreshProductList();
            this.pushHistoryState();
            this.injectModeToFacetFiltersForm();
        }
    }
    updateMode(mode, target) {
        this.currentMode = mode;
        this.displayModeButton.forEach(span => span.classList.remove('active-dot'));
        target.classList.add('active-dot');
    }

    pushHistoryState() {
        const url = new URL(window.location);
        url.searchParams.set('display', this.currentMode);
        window.history.pushState({}, '', url);
    }

    injectModeToFacetFiltersForm() {
        const form = document.getElementById(this.facetFiltersFormId);
        if (form) {
            let input = form.querySelector('input[name="mode"]');
            if (!input) {
                input = document.createElement('input');
                input.type = 'hidden';
                input.name = 'mode';
                form.appendChild(input);
            }
            input.value = this.currentMode;
        }
    }

    _onClickHandle(event, target) {
        const mode = target.getAttribute('data-mode'); // Read mode from data-mode attribute
        if (mode !== this.currentMode) {
            this.updateMode(mode, target);
            this.refreshProductList();
            this.pushHistoryState();
            this.injectModeToFacetFiltersForm();
        }
    }

    refreshProductList() {
        let productListInner = document.querySelector('.product-list__inner');
        const mode = this.currentMode;
        if (!productListInner) return; // Guard clause in case element is not found

        // Remove all possible grid classes
        productListInner.classList.remove('grid-full', 'grid-more', 'grid-thumbs');
        productListInner.classList.add('loading');

        this._staggerProductsApparition()

        setTimeout(() => {
            productListInner.classList.remove('loading');
            productListInner.classList.add(`grid-${mode}`);
        }, 200);
    }

    async _staggerProductsApparition() {
        this.productItems.forEach((item) => item.style.opacity = 0);
        await this.untilVisible({ threshold: this.clientHeight > 0 ? Math.min(50 / this.clientHeight, 1) : 0 });
        this.apparitionAnimation.play();
    }

    get apparitionAnimation() {
        return this._animation = this._animation || new CustomAnimation(new ParallelEffect(this.productItems.map((item, index) => {
            return new CustomKeyframeEffect(item, {
                opacity: [0, 1],
                transform: [`translateY(${MediaFeatures.prefersReducedMotion() ? 0 : window.innerWidth < 1e3 ? 35 : 60}px)`, "translateY(0)"]
            }, {
                duration: 600,
                delay: MediaFeatures.prefersReducedMotion() ? 0 : 100 * index - Math.min(3 * index * index, 100 * index),
                easing: "ease"
            });
        })));
    }
}

customElements.define('product-display-toggle', ProductDisplayToggle);